import React, { useState } from 'react';
import { FolderCard } from '../FolderCard';
import { MediaCard } from '../MediaCard';
import styled from 'styled-components';
import { IMediaItem } from 'modules/media/interfaces/api';
import { MediaPreviewModal } from '../MediaPreviewModal';

const MediaManagerGridMode = ({
  items,
  onOpenFolder,
  currentPath,
}: {
  items: IMediaItem[];
  onOpenFolder: (folder: IMediaItem) => void;
  currentPath: string;
}) => {
   const [previewIndex, setPreviewIndex] = useState<number | null>(null);
   const mediaItems = items.filter(i => i.type !== 'FOLDER');

   const handlePreview = (id: string) => {
     setPreviewIndex(mediaItems.findIndex(i => i.id === id));
   };
   
  return (
  <>
    <Container>
      {items.map((item) =>
        item.type === 'FOLDER' ? (
          <FolderCard key={item.id} item={item} onClick={() => onOpenFolder(item)} length={item.children?.length} currentPath={currentPath}/>
        ) : (
          <MediaCard key={item.id} item={item} onClick={() => handlePreview(item.id)} currentPath={currentPath} />
        )
      )}
    </Container>
    {previewIndex !== null && (
        <MediaPreviewModal
          items={mediaItems}
          initialIndex={previewIndex}
          onClose={() => setPreviewIndex(null)}
          setPreviewIndex={setPreviewIndex}
        />
      )}
    </>
  );
};

export default MediaManagerGridMode;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;